import { Type } from "class-transformer";
import { IsUUID, IsString, IsArray, IsBoolean, IsNumber, IsOptional, ValidateNested } from "class-validator";

class Range {
  @IsNumber()
  from: number;
  @IsNumber()
  to: number;
}

export class QuizSelection {
  @IsUUID()
  quizSelectionId: string;
  @IsString()
  categoryId: string;
  @IsString()
  modeId: string;
  @IsArray()
  @IsString({ each: true })
  topicIds: Array<string>;
  @IsBoolean()
  showAnswers: boolean;
  @IsBoolean()
  shuffleAnswers: boolean;
  @IsOptional() // TODO remove from data in migration later
  @IsBoolean()
  singleChoice?: boolean;
  @IsBoolean()
  allQuestionsAtOnce: boolean;
  @IsBoolean()
  allowQuestionReminders: boolean;
  @ValidateNested()
  @Type(() => Range)
  selectQuestionsRange: Range;
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  selectQuestionAreas: null | string[];
  @IsNumber()
  questionsPerQuiz: number;
  @IsBoolean()
  questionsPreddefined: boolean;
  @IsNumber()
  answersToChooseFrom: number;
  @IsOptional()
  @IsNumber()
  timer: null | number;
}
